<template>
    <div class="container">
        <section class="area--main area--sidebar">
            <aside id="sidebar">
                <div>
                    <sidebar></sidebar>
                </div>
            </aside>
            <div id="main">
                <div>
                    <div v-if="showFilteredView() || $store.state.searchTerm">
                        <filter-info
                            v-if="filtersLoaded"
                            @remove-filterentry="toggleFilter"
                            @remove-filter="clearFilter"
                            :filter="$store.state.currentFilters"
                            :rating="$store.state.rating"
                            :downloads="$store.state.downloads"
                            :searchterm="$store.state.searchTerm"></filter-info>
                        <div class="plugin__grid">
                            <template v-if="$store.state.currentFilteredPlugins">
                                <plugin-entry
                                    v-for="plugin in $store.state.currentFilteredPlugins" 
                                    :key="plugin.id"
                                    :id="plugin.id"
                                    :logo="plugin.image"
                                    :size="128"
                                    :title="plugin.name"
                                    :short_description="plugin.short_description"
                                    :technologies="plugin.technologies"
                                    :brands="plugin.brands"
                                    :rating="plugin.rating"
                                    :creator="plugin.creator"
                                    :highlight="plugin.highlight"
                                    :certified="plugin.certified"
                                    :type="plugin.type"></plugin-entry>
                            </template>
                            <template v-else>
                                <plugin-entry-placeholder
                                    v-for="plugin in 30"
                                    :key="plugin"></plugin-entry-placeholder>
                            </template>
                        </div>
                    </div>
                    <div v-else>
                        <page-slider></page-slider>
                        <plugin-category
                            :title="$t('page.home.featured.title')"
                            :filterInfo="{'featured': '1'}"
                            :filterMeta="{'label': 'Custom','value': 'custom','entries': {'1': {'id': 1,'label': 'Featured','value': 'Featured','selected': true}}}"
                            :plugins="featuredPlugins"
                        ></plugin-category>
                        <plugin-category
                            :title="'works with Loxone'"
                            :filterInfo="{'certified': '1'}"
                            :filterMeta="{'label': 'Certification','value': 'certification','entries': {'1': {'id': 1,'label': 'works with Loxone','value': 'loxone_ready','selected': true}}}"
                            :plugins="certifiedPlugins"
                        ></plugin-category>
                        <plugin-category
                            :title="$t('page.home.popular.title')"
                            :filterInfo="{'featured': '0'}"
                            :filterMeta="{'label': 'Custom','value': 'custom','entries': {'1': {'id': 1,'label': 'Popular','value': 'Popular','selected': true}}}"
                            :plugins="popularPlugins"
                        ></plugin-category>
                        <plugin-category
                            :title="$t('page.home.newest.title')"
                            :plugins="newestPlugins"
                            :filterInfo="{}"
                            :filterMeta="{'label': 'Custom','value': 'custom','entries': {'1': {'id': 1,'label': 'New','value': 'New','selected': true}}}"
                            :orderInfo="'id_desc'"
                        ></plugin-category>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss" scoped>
    @import '../scss/modules/structure2';
</style>

<script>
    import axios from 'axios';
    import PluginCategory from '@/components/PluginCategory.vue';
    import PluginEntry from '@/components/PluginEntry.vue';
    import PluginEntryPlaceholder from '@/components/PluginEntryPlaceholder.vue';
    import FilterInfo from '@/components/FilterInfo.vue';
    import PageSlider from '@/components/PageSlider.vue';
    import Sidebar from '@/components/Sidebar.vue';

    export default {
        name: 'Home',

        components: {
            PluginCategory,
            PluginEntry,
            PluginEntryPlaceholder,
            FilterInfo,
            PageSlider,
            Sidebar
        },

        data() {
            return {
                filtersLoaded: false,
                filteredPlugins: null,
                filteredPluginsFilter: this.$store.state.pluginsFilter,

                featuredPlugins: null,
                featuredPluginsFilter: {
                    featured: '1',
                },
                certifiedPlugins: null,
                certifiedPluginsFilter: {
                    certified: '1',
                },
                popularPlugins: null,
                popularPluginsFilter: {
                    featured: '0',
                },
                newestPlugins: null,
                newestPluginsFilter: [
                ],
            }
        },

        methods: {
            replaceValuesWithKeys(array, dictionary) {
                let result = [];

                for(let i = 0; i < array.length; i++) {
                    result.push(this.getObjKey(dictionary, array[i]));
                }

                return result;
            },
            getObjKey(obj, value) {
                return Object.keys(obj).find(key => obj[key] === value);
            },
            toggleFilter(filter, filterby, isSelected){
                this.$store.dispatch('toggleFilter', {filter, filterby, isSelected})
            },
            clearFilter() {
                this.$store.dispatch('clearFilter');
            },
            showFilteredView(){
                if(this.$store.state.pluginsFilter.technologies.length ||
                    this.$store.state.pluginsFilter.categories.length ||
                    this.$store.state.pluginsFilter.creators.length ||
                    this.$store.state.pluginsFilter.rating.length ||
                    this.$store.state.pluginsFilter.custom.length ||
                    this.$store.state.pluginsFilter.downloads.length ||
                    this.$store.state.pluginsFilter.certified.length){
                    return true;
                }
                return false;
            }

        },

        computed: {
            searchTerm() {
                return this.$store.state.searchTerm;
            }
        },

        watch: {
            searchTerm (){
                this.$store.dispatch('loadFilteredPlugins')
            }
        },

        created() {


            axios({
                method: 'post',
                    withCredentials: true,
                url: 'https://api.library.loxone.com/loadFilters',
                headers: {'Content-Type': 'multipart/form-data' },
            }).then(resp => {
                
                if(window.location.search.length > 0) {
                    let entryArray = window.location.search.split('?')[1].split('&');
                    for (let i = 0; i < entryArray.length; i++) {
                        let entry = entryArray[i].split('=');
                        let subEntry = entry[1].split(',');
                        for (let e = 0; e < subEntry.length; e++) {
                            if(entry[0] === 't') {
                                resp.data.technology.entries[this.getObjKey(this.$store.state.clear_text_technologies, subEntry[e])].selected = true;
                            }
                            if(entry[0] === 'c') {
                                resp.data.category.entries[this.getObjKey(this.$store.state.clear_text_categories, subEntry[e])].selected = true;
                            }
                            if(entry[0] === 'wwl') {
                                resp.data.certified.entries[this.getObjKey(this.$store.state.clear_text_certified, subEntry[e])].selected = true;
                            }
                            if(entry[0] === 'cr') {
                                resp.data.creator.entries[this.getObjKey(this.$store.state.clear_text_creator, subEntry[e])].selected = true;
                            }
                        }

                    }
                }



                this.filtersLoaded = true;
                this.$store.state.currentFilters = resp.data
            });

            if(Object.keys(this.$route.query).length > 0) {
                if(this.$route.query.s) {  
                    this.$store.state.searchTerm = decodeURIComponent(this.$route.query.s.replace(/\+/g, '%20'));
                }

                if(this.$route.query.t) {
                    this.$store.state.pluginsFilter.technologies = this.replaceValuesWithKeys(this.$route.query.t.split(','), this.$store.state.clear_text_technologies);
                }

                if(this.$route.query.c) {
                    this.$store.state.pluginsFilter.categories = this.replaceValuesWithKeys(this.$route.query.c.split(','), this.$store.state.clear_text_categories);
                }

                if(this.$route.query.wwl) {
                    this.$store.state.pluginsFilter.certified = this.replaceValuesWithKeys(this.$route.query.wwl.split(','), this.$store.state.clear_text_certified);
                }

                if(this.$route.query.cr) {
                    this.$store.state.pluginsFilter.creators = this.replaceValuesWithKeys(this.$route.query.cr.split(','), this.$store.state.clear_text_creator);
                }

                
                this.$store.dispatch('loadFilteredPlugins');
            }
            
            //Get Featured Plugins
            var featuredPlugins = new FormData();
            featuredPlugins.append('filter', JSON.stringify(this.featuredPluginsFilter));
            featuredPlugins.append('orderby', 'p.plugin_displayname');
            featuredPlugins.append('order', 'DESC');
            featuredPlugins.append('limit', '0,3');
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadFilteredPlugins',
                data: featuredPlugins,
            }).then(response => (this.featuredPlugins = response.data));

            //Get Popular Plugins
            var popularPlugins = new FormData();
            popularPlugins.append('filter', JSON.stringify(this.popularPluginsFilter));
            popularPlugins.append('orderby', 'p.plugin_downloads');
            popularPlugins.append('order', 'DESC');
            popularPlugins.append('limit', '0,3');
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadFilteredPlugins',
                data: popularPlugins,
            }).then(response => (this.popularPlugins = response.data));


            //Get Certified Plugins
            var certifiedPlugins = new FormData();
            certifiedPlugins.append('filter', JSON.stringify(this.certifiedPluginsFilter));
            certifiedPlugins.append('orderby', 'p.id');
            certifiedPlugins.append('order', 'ASC');
            certifiedPlugins.append('limit', '0,3');
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadFilteredPlugins',
                data: certifiedPlugins,
            }).then(response => (this.certifiedPlugins = response.data));

            //Get newestPlugins Plugins
            var newestPlugins = new FormData();
            newestPlugins.append('filter', JSON.stringify(this.newestPluginsFilter));
            newestPlugins.append('orderby', 'p.id');
            newestPlugins.append('order', 'DESC');
            newestPlugins.append('limit', '0,3');
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://api.library.loxone.com/loadFilteredPlugins',
                data: newestPlugins,
            }).then(response => {
                this.newestPlugins = response.data
            });
        },
    }
</script>